<script setup></script>

<template>
  <footer
    class="w-full flex flex-col lg:flex-row justify-center space-x-4 2xl:max-w-[70%] mx-auto pb-5"
  >
    <div class="mt-8 flex flex-col items-center text-xs text-gray-400">
      <img :src="require('/assets/images/mydid-logo-isotype.png')" alt="Logo" />
      <div class="flex gap-2">
        <a href="#" class="underline">Terms of use</a>
        <span>|</span>
        <a href="#" class="underline">Privacy Policy</a>
      </div>
    </div>
  </footer>
</template>

<style scoped></style>
